import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { LocalGroup } from 'us-web-services';
import CardStyles from '../../styles/CardStyles';
import ParentLocalGroupDisplay from './ParentLocalGroupDisplay';

interface Props {
  localGroups: LocalGroup[];
  getUserLocalGroups: () => void;
}

function ParentLocalGroups(props: Props) {
  const { localGroups, getUserLocalGroups } = props;
  const { classes } = CardStyles();

  return (
    <Card className={classes.sectionCard}>
      <CardContent className={classes.sectionContent}>
        <Typography className={classes.sectionHeader}>
          Local Groups
        </Typography>
        <Grid container spacing={1}>
          {localGroups.map(localGroup => (
            <ParentLocalGroupDisplay
              key={localGroup.id}
              localGroup={localGroup}
              getLocalGroups={getUserLocalGroups}
            />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ParentLocalGroups;
